import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles({
  wrapper: {
    width: '100%',
    borderRadius: '7px',
  },
});
